// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__j9GmG","active":"Dropdown_active__8jnCr","head":"Dropdown_head__tPpmK","body":"Dropdown_body__4Z-t0","link":"Dropdown_link__iMoXm"};